import { EDIT_CONTENT, GET_CONTENT_DATA, EDIT_SAMPLE_PIC, GET_SAMPLE_DATA, GET_SINGLE_SAMPLE, EDIT_EBOOK, DRAG_SAMPLELESSON_DATA, GET_INTRO_DATA, DELETE_INTRO, DELETE_SAMPLE, ADD_SAMPLE, ADD_INTRO, EDIT_SAMPLE } from "../actions/types";

const intialstate = {
    loading: false,
    content: [],
    sample: [],
    data: [],
    intro: [],
    error: ''
}
export default function (state = intialstate, action) {
    switch (action.type) {
        case EDIT_CONTENT:
            return {
                ...state,
            };
        case GET_CONTENT_DATA:
            return {
                ...state,
                content: action.payload
            };
        case GET_SAMPLE_DATA:
            return {
                ...state,
                sample: action.payload
            };
        case GET_INTRO_DATA:
            return {
                ...state,
                intro: action.payload
            };
        case DELETE_INTRO:
            return {
                ...state,
            };
        case DELETE_SAMPLE:
            return {
                ...state,
            };
        case ADD_SAMPLE:
            return {
                ...state,
                sample: action.payload
            };
        case ADD_INTRO:
            return {
                ...state,
                intro: action.payload
            };
        case EDIT_SAMPLE:
            return {
                ...state,
                // sample: action.payload
            };
        case GET_SINGLE_SAMPLE:
            return {
                ...state,
                data: action.payload
            };
        case EDIT_EBOOK:
            return {
                ...state
            };
        case DRAG_SAMPLELESSON_DATA:
            return {
                ...state
            }
        case EDIT_SAMPLE_PIC:
            return {
                ...state
            }
        default:
            return state
    }
}

